import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AccountType, Platform } from '@mnz-core/models/_enums';
import { APP_CONFIG } from '@mnz-core/injectors/app-configuration';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';
import { MNZ_PLATFORM } from '@mnz-core/injectors/platform';
import { getAppBaseUrl } from '@mnz-shared/shared.constants';

@Component({
  selector: 'app-login-tile',
  templateUrl: './login-tile.component.html',
})
export class LoginTileComponent {
  @Input() type: string;
  @Input() iconName: string;
  @Input() description: string;

  constructor(
    @Inject(APP_CONFIG) private readonly _config: IAppConfiguration,
    @Inject(MNZ_PLATFORM) private readonly _platform: Platform,
    private readonly _router: Router) {}

  readonly AccountType = AccountType;

  navigate(account: AccountType): void {
    if (this.isOauth2Enabled()) {
        this.doOauth2Redirect();
    } else {
      this.navigateToOldLogin(account);
    }
  }

  navigateToOldLogin(account: AccountType): void {
    this._router.navigate([`/inloggen/${account}`]);
  }

  private isOauth2Enabled(): boolean {
    return this._config.oauth2 && this._config.oauth2.enabled === true && AccountType[this.type] == AccountType.CARD_HOLDER;
  }

  private doOauth2Redirect () {
    // redirect to start oauth flow
    location.assign(getAppBaseUrl(this._config.contextPath) + '/start-oauth2');
  }
}
